// extracted by mini-css-extract-plugin
export default {"moreButton":"CohortList_moreButton__kyHUu","row":"CohortList_row__LtOFf","pointer":"CohortList_pointer__CUep8"};